/**
 * goodQueryStore
 * 编辑页面共用逻辑以及部分子组件与父组件通讯
 */
// import orderBackCountUtil from '../../static/js/backCountUtils/orderBackCountUtil'
// import sheetsBackCountUtil from '../../static/js/backCountUtils/sheetsBackCountUtil'
// import objectUtil from '../../static/js/objectUtil'

class goodQueryStore {
  constructor(goodQuery, initialState = {}, initialMutations, initialActions) {
    this.goodQuery = goodQuery

    //状态数据
    this.states = {
      formData: null,
    }

    //修改states的方法
    this.mutations = {
      setFormData(states, data) {
        this.states.formData = data
      },
    }
    //操作方法
    this.actions = {}

    //初始赋值自定义state
    for (let prop in initialState) {
      if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (initialMutations.hasOwnProperty(prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }

    //初始赋值自定义actions
    for (let prop in initialActions) {
      if (initialActions.hasOwnProperty(prop)) {
        this.actions[prop] = initialActions[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default goodQueryStore
